var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3 9.80005C14.3 10.2597 14.2095 10.7148 14.0336 11.1394C13.8577 11.5641 13.5999 11.9499 13.2749 12.2749C12.9499 12.5999 12.564 12.8577 12.1394 13.0336C11.7147 13.2095 11.2596 13.3 10.8 13.3C10.3404 13.3 9.88524 13.2095 9.4606 13.0336C9.03596 12.8577 8.65012 12.5999 8.32511 12.2749C8.00011 11.9499 7.7423 11.5641 7.56641 11.1394C7.39052 10.7148 7.29999 10.2597 7.29999 9.80005C7.29999 8.87179 7.66874 7.98155 8.32511 7.32518C8.98149 6.6688 9.87173 6.30005 10.8 6.30005C11.7282 6.30005 12.6185 6.6688 13.2749 7.32518C13.9312 7.98155 14.3 8.87179 14.3 9.80005Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.59 6.95205C20.398 8.34205 20.8 9.03705 20.8 9.80005C20.8 10.563 20.397 11.258 19.59 12.648L17.667 15.964C16.864 17.348 16.462 18.04 15.802 18.42C15.142 18.8 14.34 18.8 12.737 18.8H8.86299C7.25999 18.8 6.45799 18.8 5.79799 18.42C5.13799 18.04 4.73599 17.348 3.93299 15.964L2.00999 12.648C1.20299 11.258 0.799988 10.563 0.799988 9.80005C0.799988 9.03705 1.20299 8.34205 2.00999 6.95205L3.93299 3.63605C4.73599 2.25205 5.13799 1.56005 5.79799 1.18005C6.45799 0.800049 7.25999 0.800049 8.86299 0.800049H12.737C14.34 0.800049 15.142 0.800049 15.802 1.18005C16.462 1.56005 16.864 2.25205 17.667 3.63605L19.59 6.95205Z",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.bd010622fe36d35c51d7f0e617039749.svg";
export { ForwardRef as ReactComponent };